/**
 * Human-readable display names for AWS services, keyed by IAM service prefix.
 *
 * Downloaded from
 * https://github.com/fluggo/aws-service-auth-reference/blob/master/service-auth.json
 * then passed through jq:
 *   jq 'map({ (.servicePrefix): .name }) | add'
 *
 * TODO: Automate periodic collection.
 */
export const awsServices: Record<string, string> = {
  account: "AWS Account Management",
  activate: "AWS Activate",
  a4b: "Alexa for Business",
  mediaimport: "AmazonMediaImport",
  amplify: "AWS Amplify",
  amplifybackend: "AWS Amplify Admin",
  amplifyuibuilder: "AWS Amplify UI Builder",
  "kafka-cluster": "Apache Kafka APIs for Amazon MSK clusters",
  "execute-api": "Amazon API Gateway",
  apigateway: "Amazon API Gateway Management V2",
  appmesh: "AWS App Mesh",
  "appmesh-preview": "AWS App Mesh Preview",
  apprunner: "AWS App Runner",
  a2c: "AWS App2Container",
  appconfig: "AWS AppConfig",
  appfabric: "AWS AppFabric",
  appflow: "Amazon AppFlow",
  "app-integrations": "Amazon AppIntegrations",
  "application-autoscaling": "AWS Application Auto Scaling",
  "application-cost-profiler": "AWS Application Cost Profiler Service",
  arsenal: "Application Discovery Arsenal",
  discovery: "AWS Application Discovery Service",
  mgn: "AWS Application Migration Service",
  "application-transformation": "AWS Application Transformation Service",
  appstream: "Amazon AppStream 2.0",
  appsync: "AWS AppSync",
  artifact: "AWS Artifact",
  athena: "Amazon Athena",
  auditmanager: "AWS Audit Manager",
  "autoscaling-plans": "AWS Auto Scaling",
  b2bi: "AWS B2B Data Interchange",
  backup: "AWS Backup",
  "backup-gateway": "AWS Backup Gateway",
  "backup-storage": "AWS Backup storage",
  batch: "AWS Batch",
  bedrock: "Amazon Bedrock",
  billing: "AWS Billing and Cost Management",
  "bcm-data-exports":
    "AWS Billing and Cost Management And Cost Management Data Exports",
  billingconductor: "AWS Billing Conductor",
  "aws-portal": "AWS Billing and Cost Management Console",
  braket: "Amazon Braket",
  budgets: "AWS Budget Service",
  bugbust: "AWS BugBust",
  acm: "AWS Certificate Manager",
  chatbot: "AWS Chatbot",
  chime: "Amazon Chime",
  cleanrooms: "AWS Clean Rooms",
  "cleanrooms-ml": "AWS Clean Rooms ML",
  cloudformation: "AWS CloudFormation",
  clouddirectory: "Amazon Cloud Directory",
  servicediscovery: "AWS Cloud Map",
  cloud9: "AWS Cloud9",
  cloudfront: "Amazon CloudFront",
  "cloudfront-keyvaluestore": "Amazon CloudFront KeyValueStore",
  cloudhsm: "AWS CloudHSM",
  cloudsearch: "Amazon CloudSearch",
  cloudshell: "AWS CloudShell",
  cloudtrail: "AWS CloudTrail",
  "cloudtrail-data": "AWS CloudTrail Data",
  cloudwatch: "Amazon CloudWatch",
  applicationinsights: "Amazon CloudWatch Application Insights",
  evidently: "Amazon CloudWatch Evidently",
  internetmonitor: "Amazon CloudWatch Internet Monitor",
  logs: "Amazon CloudWatch Logs",
  networkmonitor: "Amazon CloudWatch Network Monitor",
  oam: "Amazon CloudWatch Observability Access Manager",
  rum: "AWS CloudWatch RUM",
  synthetics: "Amazon CloudWatch Synthetics",
  codeartifact: "AWS CodeArtifact",
  codebuild: "AWS CodeBuild",
  codecatalyst: "Amazon CodeCatalyst",
  codecommit: "AWS CodeCommit",
  codedeploy: "AWS CodeDeploy",
  "codedeploy-commands-secure": "AWS CodeDeploy secure host commands service",
  codeguru: "Amazon CodeGuru",
  "codeguru-profiler": "Amazon CodeGuru Profiler",
  "codeguru-reviewer": "Amazon CodeGuru Reviewer",
  "codeguru-security": "Amazon CodeGuru Security",
  codepipeline: "AWS CodePipeline",
  codestar: "AWS CodeStar",
  "codestar-connections": "AWS CodeStar Connections",
  "codestar-notifications": "AWS CodeStar Notifications",
  codewhisperer: "Amazon CodeWhisperer",
  "cognito-identity": "Amazon Cognito Identity",
  "cognito-sync": "Amazon Cognito Sync",
  "cognito-idp": "Amazon Cognito User Pools",
  comprehend: "Amazon Comprehend",
  comprehendmedical: "Amazon Comprehend Medical",
  "compute-optimizer": "AWS Compute Optimizer",
  config: "AWS Config",
  connect: "Amazon Connect",
  cases: "Amazon Connect Cases",
  profile: "Amazon Connect Customer Profiles",
  voiceid: "Amazon Connect Voice ID",
  awsconnector: "AWS Connector Service",
  consoleapp: "AWS Management Console Mobile App",
  consolidatedbilling: "AWS Consolidated Billing",
  controltower: "AWS Control Tower",
  cur: "AWS Cost and Usage Report",
  ce: "AWS Cost Explorer Service",
  "cost-optimization-hub": "AWS Cost Optimization Hub",
  "customer-verification": "AWS Customer Verification Service",
  dataexchange: "AWS Data Exchange",
  dlm: "Amazon Data Lifecycle Manager",
  datapipeline: "AWS Data Pipeline",
  dms: "AWS Database Migration Service",
  dbqms: "Database Query Metadata Service",
  datasync: "AWS DataSync",
  datazone: "Amazon DataZone",
  deepcomposer: "AWS DeepComposer",
  deeplens: "AWS DeepLens",
  deepracer: "AWS DeepRacer",
  detective: "Amazon Detective",
  devicefarm: "AWS Device Farm",
  "devops-guru": "Amazon DevOps Guru",
  ts: "AWS Diagnostic tools",
  directconnect: "AWS Direct Connect",
  ds: "AWS Directory Service",
  "docdb-elastic": "Amazon DocumentDB Elastic Clusters",
  dynamodb: "Amazon DynamoDB",
  dax: "Amazon DynamoDB Accelerator (DAX)",
  ec2: "Amazon EC2",
  autoscaling: "Amazon EC2 Auto Scaling",
  imagebuilder: "Amazon EC2 Image Builder",
  "ec2-instance-connect": "Amazon EC2 Instance Connect",
  "eks-auth": "Amazon EKS Auth",
  elasticbeanstalk: "AWS Elastic Beanstalk",
  ebs: "Amazon Elastic Block Store",
  ecr: "Amazon Elastic Container Registry",
  "ecr-public": "Amazon Elastic Container Registry Public",
  ecs: "Amazon Elastic Container Service",
  drs: "AWS Elastic Disaster Recovery",
  elasticfilesystem: "Amazon Elastic File System",
  "elastic-inference": "Amazon Elastic Inference",
  eks: "Amazon Elastic Kubernetes Service",
  elasticloadbalancing: "AWS Elastic Load Balancing V2",
  elasticmapreduce: "Amazon Elastic MapReduce",
  elastictranscoder: "Amazon Elastic Transcoder",
  elasticache: "Amazon ElastiCache",
  "elemental-appliances-software": "AWS Elemental Appliances and Software",
  "elemental-activations":
    "AWS Elemental Appliances and Software Activation Service",
  mediaconnect: "AWS Elemental MediaConnect",
  mediaconvert: "AWS Elemental MediaConvert",
  medialive: "AWS Elemental MediaLive",
  mediapackage: "AWS Elemental MediaPackage",
  mediapackagev2: "AWS Elemental MediaPackage V2",
  "mediapackage-vod": "AWS Elemental MediaPackage VOD",
  mediastore: "AWS Elemental MediaStore",
  mediatailor: "AWS Elemental MediaTailor",
  "elemental-support-cases": "AWS Elemental Support Cases",
  "elemental-support-content": "AWS Elemental Support Content",
  "emr-containers": "Amazon EMR on EKS (EMR Containers)",
  "emr-serverless": "Amazon EMR Serverless",
  entityresolution: "AWS Entity Resolution",
  events: "Amazon EventBridge",
  pipes: "Amazon EventBridge Pipes",
  scheduler: "Amazon EventBridge Scheduler",
  schemas: "Amazon EventBridge Schemas",
  fis: "AWS Fault Injection Service",
  finspace: "Amazon FinSpace",
  "finspace-api": "Amazon FinSpace API",
  fms: "AWS Firewall Manager",
  forecast: "Amazon Forecast",
  frauddetector: "Amazon Fraud Detector",
  freetier: "AWS Free Tier",
  freertos: "Amazon FreeRTOS",
  fsx: "Amazon FSx",
  gamelift: "Amazon GameLift",
  globalaccelerator: "AWS Global Accelerator",
  glue: "AWS Glue",
  databrew: "AWS Glue DataBrew",
  groundstation: "AWS Ground Station",
  groundtruthlabeling: "Amazon GroundTruth Labeling",
  guardduty: "Amazon GuardDuty",
  health: "AWS Health APIs and Notifications",
  "medical-imaging": "AWS HealthImaging",
  healthlake: "AWS HealthLake",
  omics: "AWS HealthOmics",
  "connect-campaigns": "High-volume outbound communications",
  honeycode: "Amazon Honeycode",
  "access-analyzer": "AWS IAM Access Analyzer",
  sso: "AWS IAM Identity Center (successor to AWS Single Sign-On)",
  "sso-directory":
    "AWS IAM Identity Center (successor to AWS Single Sign-On) directory",
  "sso-oauth": "AWS IAM Identity Center OIDC service",
  iam: "AWS Identity and Access Management (IAM)",
  rolesanywhere: "AWS Identity and Access Management Roles Anywhere",
  identitystore: "AWS Identity Store",
  "identitystore-auth": "AWS Identity Store Auth",
  "identity-sync": "AWS Identity Sync",
  importexport: "AWS Import Export Disk Service",
  inspector: "Amazon Inspector",
  inspector2: "Amazon Inspector2",
  "inspector-scan": "Amazon InspectorScan",
  ivs: "Amazon Interactive Video Service",
  ivschat: "Amazon Interactive Video Service Chat",
  invoicing: "AWS Invoicing Service",
  iot: "AWS IoT",
  iot1click: "AWS IoT 1-Click",
  iotanalytics: "AWS IoT Analytics",
  iotdeviceadvisor: "AWS IoT Core Device Advisor",
  "iot-device-tester": "AWS IoT Device Tester",
  iotevents: "AWS IoT Events",
  iotfleethub: "AWS IoT Fleet Hub for Device Management",
  iotfleetwise: "AWS IoT FleetWise",
  greengrass: "AWS IoT Greengrass V2",
  iotjobsdata: "AWS IoT Jobs DataPlane",
  iotroborunner: "AWS IoT RoboRunner",
  iotsitewise: "AWS IoT SiteWise",
  iottwinmaker: "AWS IoT TwinMaker",
  iotwireless: "AWS IoT Wireless",
  iq: "AWS IQ",
  "iq-permission": "AWS IQ Permissions",
  kendra: "Amazon Kendra",
  "kendra-ranking": "Amazon Kendra Intelligent Ranking",
  kms: "AWS Key Management Service",
  cassandra: "Amazon Keyspaces (for Apache Cassandra)",
  kinesisanalytics: "Amazon Kinesis Analytics V2",
  kinesis: "Amazon Kinesis Data Streams",
  firehose: "Amazon Kinesis Firehose",
  kinesisvideo: "Amazon Kinesis Video Streams",
  lakeformation: "AWS Lake Formation",
  lambda: "AWS Lambda",
  launchwizard: "AWS Launch Wizard",
  lex: "Amazon Lex V2",
  "license-manager": "AWS License Manager",
  "license-manager-linux-subscriptions":
    "AWS License Manager Linux Subscriptions Manager",
  "license-manager-user-subscriptions":
    "AWS License Manager User Subscriptions",
  lightsail: "Amazon Lightsail",
  geo: "Amazon Location",
  lookoutequipment: "Amazon Lookout for Equipment",
  lookoutmetrics: "Amazon Lookout for Metrics",
  lookoutvision: "Amazon Lookout for Vision",
  machinelearning: "Amazon Machine Learning",
  macie2: "Amazon Macie",
  m2: "AWS Mainframe Modernization Service",
  managedblockchain: "Amazon Managed Blockchain",
  "managedblockchain-query": "Amazon Managed Blockchain Query",
  grafana: "Amazon Managed Grafana",
  aps: "Amazon Managed Service for Prometheus",
  kafka: "Amazon Managed Streaming for Apache Kafka",
  kafkaconnect: "Amazon Managed Streaming for Kafka Connect",
  airflow: "Amazon Managed Workflows for Apache Airflow",
  "aws-marketplace": "AWS Marketplace Seller Reporting",
  marketplacecommerceanalytics: "AWS Marketplace Commerce Analytics Service",
  "aws-marketplace-management": "AWS Marketplace Management Portal",
  "vendor-insights": "AWS Marketplace Vendor Insights",
  mechanicalturk: "Amazon Mechanical Turk",
  memorydb: "Amazon MemoryDB",
  ec2messages: "Amazon Message Delivery Service",
  serviceextract: "AWS Microservice Extractor for .NET",
  mapcredits: "AWS Migration Acceleration Program Credits",
  mgh: "AWS Migration Hub",
  "migrationhub-orchestrator": "AWS Migration Hub Orchestrator",
  "refactor-spaces": "AWS Migration Hub Refactor Spaces",
  "migrationhub-strategy": "AWS Migration Hub Strategy Recommendations",
  mobileanalytics: "Amazon Mobile Analytics",
  monitron: "Amazon Monitron",
  mq: "Amazon MQ",
  "neptune-db": "Amazon Neptune",
  "neptune-graph": "Amazon Neptune Analytics",
  "network-firewall": "AWS Network Firewall",
  networkmanager: "AWS Network Manager",
  "networkmanager-chat": "AWS Network Manager Chat",
  nimble: "Amazon Nimble Studio",
  one: "Amazon One Enterprise",
  osis: "Amazon OpenSearch Ingestion",
  aoss: "Amazon OpenSearch Serverless",
  es: "Amazon OpenSearch Service",
  opsworks: "AWS OpsWorks",
  "opsworks-cm": "AWS OpsWorks Configuration Management",
  organizations: "AWS Organizations",
  outposts: "AWS Outposts",
  panorama: "AWS Panorama",
  "partnercentral-account-management": "AWS Partner central account management",
  "payment-cryptography": "AWS Payment Cryptography",
  payments: "AWS Payments",
  pi: "AWS Performance Insights",
  personalize: "Amazon Personalize",
  mobiletargeting: "Amazon Pinpoint",
  ses: "Amazon Simple Email Service v2",
  "sms-voice": "Amazon Pinpoint SMS Voice V2",
  polly: "Amazon Polly",
  pricing: "AWS Price List",
  "pca-connector-ad": "AWS Private CA Connector for Active Directory",
  "acm-pca": "AWS Private Certificate Authority",
  proton: "AWS Proton",
  "purchase-orders": "AWS Purchase Orders Console",
  q: "Amazon Q",
  qbusiness: "Amazon Q Business",
  wisdom: "Amazon Q in Connect",
  qldb: "Amazon QLDB",
  quicksight: "Amazon QuickSight",
  rds: "Amazon RDS",
  "rds-data": "Amazon RDS Data API",
  "rds-db": "Amazon RDS IAM Authentication",
  repostspace: "AWS re:Post Private",
  rbin: "AWS Recycle Bin",
  redshift: "Amazon Redshift",
  "redshift-data": "Amazon Redshift Data API",
  "redshift-serverless": "Amazon Redshift Serverless",
  rekognition: "Amazon Rekognition",
  resiliencehub: "AWS Resilience Hub",
  ram: "AWS Resource Access Manager (RAM)",
  "resource-explorer-2": "AWS Resource Explorer",
  tag: "Amazon Resource Group Tagging API",
  "resource-groups": "AWS Resource Groups",
  rhelkb: "Amazon RHEL Knowledgebase Portal",
  robomaker: "AWS RoboMaker",
  route53: "Amazon Route 53",
  "arc-zonal-shift":
    "Amazon Route 53 Application Recovery Controller - Zonal Shift",
  route53domains: "Amazon Route 53 Domains",
  "route53-recovery-cluster": "Amazon Route 53 Recovery Cluster",
  "route53-recovery-control-config": "Amazon Route 53 Recovery Controls",
  "route53-recovery-readiness": "Amazon Route 53 Recovery Readiness",
  route53resolver: "Amazon Route 53 Resolver",
  s3: "Amazon S3",
  s3express: "Amazon S3 Express",
  glacier: "Amazon S3 Glacier",
  "s3-object-lambda": "Amazon S3 Object Lambda",
  "s3-outposts": "Amazon S3 on Outposts",
  sagemaker: "Amazon SageMaker",
  "sagemaker-geospatial": "Amazon SageMaker geospatial capabilities",
  "sagemaker-groundtruth-synthetic": "Amazon SageMaker Ground Truth Synthetic",
  savingsplans: "AWS Savings Plans",
  secretsmanager: "AWS Secrets Manager",
  securityhub: "AWS Security Hub",
  securitylake: "Amazon Security Lake",
  sts: "AWS Security Token Service",
  sms: "AWS Server Migration Service",
  serverlessrepo: "AWS Serverless Application Repository",
  servicecatalog: "AWS Service Catalog",
  "private-networks": "AWS service providing managed private networks",
  servicequotas: "Service Quotas",
  ssmmessages: "Amazon Session Manager Message Gateway Service",
  shield: "AWS Shield",
  signer: "AWS Signer",
  swf: "Amazon Simple Workflow Service",
  sdb: "Amazon SimpleDB",
  simspaceweaver: "AWS SimSpace Weaver",
  "snow-device-management": "AWS Snow Device Management",
  snowball: "AWS Snowball",
  sns: "Amazon SNS",
  sqlworkbench: "AWS SQL Workbench",
  sqs: "Amazon SQS",
  states: "AWS Step Functions",
  storagegateway: "AWS Storage Gateway",
  scn: "AWS Supply Chain",
  support: "AWS Support",
  supportapp: "AWS Support App in Slack",
  supportplans: "AWS Support Plans",
  sustainability: "AWS Sustainability",
  ssm: "AWS Systems Manager",
  "ssm-sap": "AWS Systems Manager for SAP",
  "ssm-guiconnect": "AWS Systems Manager GUI Connect",
  "ssm-incidents": "AWS Systems Manager Incident Manager",
  "ssm-contacts": "AWS Systems Manager Incident Manager Contacts",
  tax: "AWS Tax Settings",
  tnb: "AWS Telco Network Builder",
  textract: "Amazon Textract",
  timestream: "Amazon Timestream",
  tiros: "AWS Tiros",
  transcribe: "Amazon Transcribe",
  transfer: "AWS Transfer Family",
  translate: "Amazon Translate",
  trustedadvisor: "AWS Trusted Advisor",
  notifications: "AWS User Notifications",
  "notifications-contacts": "AWS User Notifications Contacts",
  "verified-access": "AWS Verified Access",
  verifiedpermissions: "Amazon Verified Permissions",
  "vpc-lattice": "Amazon VPC Lattice",
  "vpc-lattice-svcs": "Amazon VPC Lattice Services",
  waf: "AWS WAF",
  "waf-regional": "AWS WAF Regional",
  wafv2: "AWS WAF V2",
  wellarchitected: "AWS Well-Architected Tool",
  wickr: "AWS Wickr",
  workdocs: "Amazon WorkDocs",
  worklink: "Amazon WorkLink",
  workmail: "Amazon WorkMail",
  workmailmessageflow: "Amazon WorkMail Message Flow",
  workspaces: "Amazon WorkSpaces",
  wam: "Amazon WorkSpaces Application Manager",
  thinclient: "Amazon WorkSpaces Thin Client",
  "workspaces-web": "Amazon WorkSpaces Web",
  xray: "AWS X-Ray",
};
